/**
 * i18n configuration file
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ICU from 'i18next-icu';
import './dayjs';

// common
import ru_common from './ru/common.json';
import en_common from './en/common.json';
import sr_common from './sr/common.json';

// account
import ru_account from './ru/account.json';
import en_account from './en/account.json';
import sr_account from './sr/account.json';

// auth/registration
import ru_registration from './ru/registration.json';
import en_registration from './en/registration.json';
import sr_registration from './sr/registration.json';

// auth errors/messages
import ru_auth from './ru/auth.json';
import en_auth from './en/auth.json';
import sr_auth from './sr/auth.json';

// onboarding
import ru_onboarding from './ru/onboarding.json';
import en_onboarding from './en/onboarding.json';
import sr_onboarding from './sr/onboarding.json';

//menu
import ru_menu from './ru/menu.json';
import en_menu from './en/menu.json';
import sr_menu from './sr/menu.json';

//pets
import en_pets from './en/pets.json';
import ru_pets from './ru/pets.json';
import sr_pets from './sr/pets.json';

//events
import en_events from './en/events.json';
import ru_events from './ru/events.json';
import sr_events from './sr/events.json';

//breeds
import en_breeds from './en/breeds.json';
import ru_breeds from './ru/breeds.json';
import sr_breeds from './sr/breeds.json';

// landing
import en_landing from './en/landing.json';
import ru_landing from './ru/landing.json';
import sr_landing from './sr/landing.json';

// admin (ops / internal)
import en_admin from './en/admin.json';
import ru_admin from './ru/admin.json';
import sr_admin from './sr/admin.json';


const namespaces = ['common', 'auth', 'pet', 'account', 'registration', 'onboarding', 'menu', 'pets', 'events', 'breeds', 'landing', 'admin'];

i18n
  .use(LanguageDetector)
  .use(new ICU())
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['ru', 'sr', 'en'],
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    cleanCode: true,
    lowerCaseLng: true,
    ns: namespaces,
    defaultNS: 'common',
    resources: {
      ru: { common: ru_common, auth: ru_auth, account: ru_account, registration: ru_registration, onboarding: ru_onboarding, menu: ru_menu, pets: ru_pets, events: ru_events, breeds: ru_breeds, landing: ru_landing, admin: ru_admin },
      en: { common: en_common, auth: en_auth, account: en_account, registration: en_registration, onboarding: en_onboarding, menu: en_menu, pets: en_pets, events: en_events, breeds: en_breeds, landing: en_landing, admin: en_admin },
      sr: { common: sr_common, auth: sr_auth, account: sr_account, registration: sr_registration, onboarding: sr_onboarding, menu: sr_menu, pets: sr_pets, events: sr_events, breeds: sr_breeds, landing: sr_landing, admin: sr_admin },
    },
    detection: { order: ['querystring', 'localStorage', 'navigator'], caches: ['localStorage'] },
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
    initImmediate: false,
  });

export async function ensureNamespaces(nsList = []) {
  const lng = (i18n.resolvedLanguage || i18n.language || 'ru').split('-')[0];
  await Promise.all(
    nsList.map(async (ns) => {
      if (i18n.hasResourceBundle(lng, ns)) return;
      const mod = await import(`./${lng}/${ns}.json`);
      i18n.addResourceBundle(lng, ns, mod.default || mod, true, true);
    })
  );
}

if (process.env.NODE_ENV === 'development') window.__i18n = i18n;
export default i18n;

